// extracted by mini-css-extract-plugin
module.exports = {"counterList":"CounterList_counterList__BchyZ","counterListBorderBottomDotted":"CounterList_counterListBorderBottomDotted__YHycj"};